export const YA_ID_DEMO = 105519557;
export const YA_ID = 100768940;
export const YANDEX_METRIKA_ID = YA_ID;

export const YM_GOALS = {
  REGISTRATION_SUBMIT: "registration_submit",
  REGISTRATION_SUCCESS: "registration_success",
  REGISTRATION_STEP: (step: number) => `registration_step_${step}`,
  LOGIN_FORM_OPEN: "login_form_open",
  LOGIN_SUBMIT: "login_submit",
  AUTORIZATION_FORM_OPEN: "autorization_form_open",
  AUTORIZATION_SUBMIT: "autorization_submit",
  PROFILE_UPDATE: "profile_update",
  GO_TO_MAIN: "go_to_main_page",
  YANDEX_LOGIN: "yandex_login_click",
};
